export default __webpack_public_path__ + "static/media/hero-3.c3ad4042.jpg";